import { Routes, Route, Navigate } from "react-router-dom";

import PrivacyPolicy from "../pages/PrivacyPolicy";
import Contact from "../pages/Contact";
import FAQs from "../pages/FAQs";
import Fleet from "../pages/Fleet";
import Home from "../pages/Home";
import VehicleDetail from "../pages/VehicleDetail";

const DefaultRoutes = () => {

    return (
        <Routes>
            <Route path="privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="contact" element={<Contact />} />
            <Route path="faqs" element={<FAQs />} />
            <Route path="vehicles/:vehicleId" element={<VehicleDetail />} />
            <Route path="vehicles" element={<Fleet />} />
            <Route path="fleet" element={<Navigate to="/vehicles" replace />} />
            <Route path="home" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Home />} />
        </Routes>
    )
}

export default DefaultRoutes